import { openChatWindow } from '@lessonup/intercom-classic';
import { EmailVerificationSent, showEmailTroubleshootModal } from '@lessonup/teacher-modern';
import { registerRoute } from '@lessonup/typescript-core/services';
import React from 'react';
import { PageWrapper } from '../../../components/PageWrapper/PageWrapper';
import { ClientOnlyModernWrapper } from '../../../utils/bridge/ClientOnlyModernWrapper';
import { RegistrationFormProps, RegistrationPageProps } from '../types';
import { useRegistrationContext } from '../utils/RegistrationContext';

type Props = RegistrationFormProps & RegistrationPageProps;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- auto-generated TECH-258
export const RegistrationEmailVerificationSentServiceWrapper = (props: Props) => {
  const { email } = useRegistrationContext();

  return (
    <PageWrapper>
      <ClientOnlyModernWrapper>
        <EmailVerificationSent
          emailAddress={email}
          changeEmailLink={registerRoute('credentials')}
          onTroubleshootClick={(emailAddress: string) =>
            showEmailTroubleshootModal({
              openChatWindow,
              changeEmailLink: registerRoute('credentials'),
              emailAddress,
            })
          }
        />
      </ClientOnlyModernWrapper>
    </PageWrapper>
  );
};
